import { useQuery } from "react-query";
import { AxiosError } from "axios";
import http from "infra/http";
import { OrcamentoItemPdfResponse } from "../typings";

function useItemsOrcamentoPdf(id?: string) {
  return useQuery<OrcamentoItemPdfResponse, AxiosError>(
    `/v1/orcamento/${id}/pdf`,
    async () => {
      const { data } = await http.get<OrcamentoItemPdfResponse>(
        `/v1/orcamento/${id}/pdf`
      );

      return data;
    },
    { enabled: !!id }
  );
}

export default useItemsOrcamentoPdf;
